// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"889cecf9","171":"49118595","374":"177a7f02","466":"71cbdd32","507":"ea446643","595":"1c5f7fb7","949":"c6051976"}[chunkId] + ".chunk.js";
};